import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Select from "react-select";

const TrainingAttendanceForm = (props) => {
  const frmRef = useRef({});
  const farmerRef = useRef({});

  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "230px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };

  const [ageRange, setAgeRange] = useState("");
  const [gender, setGender] = useState("");
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 50,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "4%",
      left: "40%",
      borderRadius: "5px",
      maxWidth: "650px",
      maxHeight: "700px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [isOpen, setIsOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const attachmentFolder = localStorage.getItem("attachmentFolder");

  const handleAttachmentChange = (e) => {
    const files = e.target.files;

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });


    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/trainingAttendance/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const [trainingDetailId, setTrainingDetailId] = useState();
  const [farmerListData, setFarmerListData] = useState([]);
  const [farmerData, setFarmerData] = useState([]);
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState();

  const [trainingCode, setTrainingCode] = useState();
  const { sendRequest: getFarmers } = useHttp();


  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);
  useEffect(() => {
    getFarmers(
      {
        url: `/api/farmerEnrolmentDetailreport/?fieldExecutiveId=${parseInt(
          localStorage.getItem("id")
        )}&&empId=${parseInt(
          localStorage.getItem("empId"))}`,

        // url: `/api/farmerEnrolmentDetailreport/?empId=${parseInt(
        //   localStorage.getItem("empId"))}`,
      },
      (data) => {
        setFarmerData(data)
        var farmerTempList = []
        farmerTempList = farmerTempList.concat({
          "value": "New Farmer",
          "label": "New Farmer"
        })

        var list = data &&
          data.map((x) => ({
            value: x.farmerId,
            label: x.farmerName,
          }))
        farmerTempList = farmerTempList.concat(list)
        setFarmerListData(farmerTempList);
      }
    );
  }, []);

  const submitAttendanceDetails = (e) => {
    e.preventDefault();

    if (!selectedFarmer) {
      toast.error("Please select a farmer.");
      return;
    }

    const contactNumber = farmerRef.current.contact_number.value;



    const farmerExists =
      attendanceDetails &&
      attendanceDetails.some((item) => item.farmerId === selectedFarmer.value);

    if (farmerExists) {
      toast.error("This farmer is already Exists.");
      return;
    }

    var farmerId = selectedFarmer && selectedFarmer.value
    if (selectedFarmer && selectedFarmer.value == "New Farmer") {
      farmerId = "0";
    }

    setAttendanceDetails((x) => [
      ...x,
      {
        farmerTrainingAttendanceDetailId: generateUniqueID(),
        farmerId: farmerId,
        farmerName: farmerRef.current.farmerName.value,
        ageRange: ageRange,
        gender: gender,
        contactNo: contactNumber,
        farmerCountry: farmerRef.current.farmerCountry.value,
        farmerState: farmerRef.current.farmerState.value,
        farmerCity: farmerRef.current.farmerCity.value,
        farmerVillage: farmerRef.current.farmerVillage.value,
        farmerAddress: farmerRef.current.farmerAddress.value,
        entryLatLong: entryLatLong,
      },
    ]);

    farmerRef.current.contact_number.value = "";
    setSelectedFarmer("");
  };

  const handleDelete = (index, e) => {
    setAttendanceDetails(attendanceDetails.filter((v, i) => i !== index));
  };

  const handleFarmerChange = (option) => {
    setSelectedFarmer(option);
    console.log("option", option)
    var farmerObj = farmerData.filter(e => e.farmerId == option.value)

    if (farmerObj && farmerObj.length > 0) {
      var fitem = farmerObj[0]
      console.log("frmRef", fitem)

      farmerRef.current.farmerName.value = fitem["farmerName"]
      farmerRef.current.contact_number.value = fitem["mobile"]
      farmerRef.current.LGA.value = fitem["lga"]
      setAgeRange(fitem["ageRange"])
      setGender(fitem["gender"])
      farmerRef.current.farmerCountry.value = fitem["country"]
      farmerRef.current.farmerState.value = fitem["state"]
      farmerRef.current.farmerCity.value = fitem["city"]
      farmerRef.current.farmerVillage.value = fitem["villageName"]
      farmerRef.current.farmerAddress.value = fitem["address"]
    }







  };

  const { sendRequest: getTrainingCode } = useHttp();

  useEffect(() => {
    getTrainingCode(
      {
        url: `/api/getMeetingList/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${parseInt(localStorage.getItem("id"))}`,
      },
      (data) => {
        // //console.log(data);
        setTrainingCode(data);
      }
    );
  }, []);

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID = currentDateTime.getTime();
    return uniqueID.toString();
  }

  const { sendRequest: postAttendance } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("attendanceDetails", attendanceDetails)
    const input = {
      farmerTrainingAttendanceId: generateUniqueID(),
      dateOfTraining: moment(frmRef.current.training_date.value).format(
        "DD/MM/YYYY"
      ),

      trainingDetailId: frmRef.current.training_code.value,
      farmerTrainingAttendanceDetails: attendanceDetails,
      fileAttachment: uploadedFiles,
      fileAttachment: uploadedFiles,
      entryLatLong: entryLatLong,
      orgId: parseInt(localStorage.getItem("orgId")),
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
    };
    // //console.log(input);
    postAttendance(
      {
        url: "/api/farmerTraining/",
        method: props.update ? "PUT" : "POST",
        body: input,
      },
      (data) => {
        // //console.log(data);

        toast.success(
          `Training Attendance  ${props.update ? "Updated" : "Added"
          } Successfully`
        );
        props.addForm(false);
      }
    );
  };

  if (props.update) {
    console.log("frmRef", frmRef)
    setTrainingDetailId(props.update.trainingDetailId);
  }

  return (
    <>
      {isOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <form onSubmit={submitAttendanceDetails}>
            <div className="">
              <h3 className="card-title">Farmer Attendance List</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div>
              <div className="row">
                <div className="col-md-6">
                  <label>Select Farmer</label>
                  <Select
                    styles={customStyles}
                    options={farmerListData}
                    value={selectedFarmer}
                    onChange={(option) => {
                      handleFarmerChange(option);
                    }}
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label>Farmer Name</label>
                  <input
                    id="farmerName"
                    name="contact_number"
                    ref={(el) => (farmerRef.current["farmerName"] = el)}


                    className="form-control"
                    required
                  />
                </div>


                <div className="col-md-6">
                  <label>Contact Number</label>
                  <input
                    id="contact_number"
                    name="contact_number"
                    ref={(el) => (farmerRef.current["contact_number"] = el)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label>Age Range</label>
                  <select
                    id="address_type"
                    className="form-control"
                    value={ageRange}
                    onChange={(e) => setAgeRange(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Registered">18-39</option>
                    <option value="Billing">40 Above</option>
                  </select>
                </div>


                <div className="col-md-3">
                  <label> Gender</label>
                  <select
                    className="form-control"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label> LGA</label>
                  <input
                    id="LGA"
                    name="LGA"
                    ref={(el) => (farmerRef.current["LGA"] = el)}
                    className="form-control"
                    required
                  />
                </div>



                <div className="col-md-6">
                  <label>Frequency Of Training To Farmer</label>
                  <input
                    id="frequencyOfTrainingToFarmer"
                    name="frequencyOfTrainingToFarmer"
                    ref={(el) => (farmerRef.current["frequencyOfTrainingToFarmer"] = el)}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label> Country</label>
                  <input
                    id="farmerCountry"
                    name="farmerCountry"
                    ref={(el) => (farmerRef.current["farmerCountry"] = el)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-5">
                  <label>State</label>
                  <input
                    id="farmerState"
                    name="farmerState"
                    ref={(el) => (farmerRef.current["farmerState"] = el)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label>City</label>
                  <input
                    id="farmerCity"
                    name="farmerCity"
                    ref={(el) => (farmerRef.current["farmerCity"] = el)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label>Village</label>
                  <input
                    id="farmerVillage"
                    name="farmerVillage"
                    ref={(el) => (farmerRef.current["farmerVillage"] = el)}
                    className="form-control"
                    required
                  />
                </div>






                <div className="col-md-6">
                  <label>Address</label>
                  <input
                    id="farmerAddress"
                    name="farmerAddress"
                    ref={(el) => (farmerRef.current["farmerAddress"] = el)}
                    className="form-control"
                    required
                  />
                </div>










                <div className="col-md-3">
                  <br />
                  <button type="submit" className="btn  btn-secondary">
                    +
                  </button>
                </div>
              </div>
              <br />

              <div className="row">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Farmer Name</th>
                      <th>Contact Number</th>

                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendanceDetails &&
                      attendanceDetails.map((itm, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.farmerName}</td>
                          <td>{itm.contactNo}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => handleDelete(i)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>

                </table>
              </div>

              <div className="text-center">
                <button
                  type="button"
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
          <br />
          <div>

          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Training Attendance Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date of Training</label>

                        <input
                          type={"date"}
                          id={"training_date"}
                          required
                          ref={(el) => (frmRef.current["training_date"] = el)}
                          className="form-control"
                          max={currentDate}
                          value={selectedDate}
                          onChange={handleDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Training Code </label>

                        <select
                          type={"text"}
                          id={"training_code"}
                          value={trainingDetailId}
                          required
                          ref={(el) => (frmRef.current["training_code"] = el)}
                          className="form-control"
                          onChange={(e) => {
                            var id = "0"
                            if (e.target.value != "") {
                              id = e.target.value
                            }
                            setTrainingDetailId(id);
                          }}

                        >
                          <option value="">Select</option>
                          {trainingCode &&
                            trainingCode.map((x) => (
                              <option
                                key={x.trainingDetailId}
                                value={x.trainingDetailId}
                              >
                                {x.docNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Add Farmer</label>
                        <br />
                        <button
                          className="btn  btn-success mx-2 my-2"
                          type="button"
                          onClick={() => {
                            setIsOpen(true);
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default TrainingAttendanceForm;
